import Service from '@ember/service';
import Evented from '@ember/object/evented';

export default class EventBus extends Service.extend(Evented) {}
